import styled from '@emotion/styled'
import {
  closeModal,
  resetRevenueCenter,
  selectCartTotal,
  toggleSidebar,
  useAppDispatch,
  useAppSelector,
} from '@open-tender/cloud'
import { Button, ButtonLink, Heading, ModalContent, ModalView } from 'components'

const OrderRestrictionTotal = styled.div`
  text-align: center;
  margin: 0 0 1.5rem;

  p:first-of-type {
    font-size: ${(props) => props.theme.fonts.sizes.xBig};
  }
`

const OrderRestrictionFooter = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1.5rem;
`

export interface OrderRestrictionProps {
  message: string
}

/**
 * Figma "ORDER RESTRICTION": shown instead of the generic order-time modal
 * when the backend says a smaller cart would still be ready before close.
 */
const OrderRestriction = ({ message }: OrderRestrictionProps) => {
  const dispatch = useAppDispatch()
  const cartTotal = useAppSelector(selectCartTotal)

  const editCart = () => {
    dispatch(closeModal())
    dispatch(toggleSidebar())
  }

  const changeLocation = () => {
    dispatch(resetRevenueCenter())
    dispatch(closeModal())
  }

  return (
    <ModalView>
      <ModalContent
        title="Order Restriction"
        footer={
          <OrderRestrictionFooter>
            <Button onClick={editCart}>Edit Cart</Button>
            <ButtonLink onClick={changeLocation}>
              Nevermind, Choose a different location
            </ButtonLink>
          </OrderRestrictionFooter>
        }
      >
        <OrderRestrictionTotal>
          <p>
            <Heading>${cartTotal.toFixed(2)}</Heading>
          </p>
          <p>Current Total</p>
        </OrderRestrictionTotal>
        <p>{message}</p>
      </ModalContent>
    </ModalView>
  )
}

export default OrderRestriction
